var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg7Eleven(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    viewBox: "25.959 39.274 219.242 219.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.39 -13.311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.567 59.459h133.887c-13.182 4.941-53.313 32.112-63.335 50.38H74.685l-.118-50.38z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.272 203.817c-1.911 18.244-1.99 40.462-1.99 63.8h-58.03c0-23.338.974-45.556 2.885-63.8h57.135z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M82.212 184.524v7.074h9.282v8.105H70.278v-37.717h21.216v8.401h-9.282v7.066h9.282v7.071z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M131.586 184.524v7.074h9.242v8.105h-21.176v-37.717h21.176v8.401h-9.242v7.066h9.242v7.071z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M185.912 184.524v7.074h9.282v8.105h-21.216v-37.717h21.216v8.401h-9.282v7.066h9.282v7.071z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M116.687 191.598v8.105H95.472v-37.717h11.934v29.612z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M143.013 161.986l5.927 37.717h15.327l7.176-37.717h-8.853l-4.64 25.491-4.525-25.491z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M211.692 199.699h-11.467v-37.713h11.467z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.691 173.183c.624-4.13 6.474-3.022 6.474-.663v27.183h11.505v-31.968c0-6.779-9.555-9.505-17.9-3.538l-.079 8.986z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.654 156.682c1.17-14.434 20.942-38.005 40.091-44.195V56.803c-52.688 23.572-86.93 59.222-94.34 99.738l54.249.14z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7Eleven);
export default __webpack_public_path__ + "static/media/7-eleven.d978d209e21edcd73285bd57dad8aa7e.svg";
export { ForwardRef as ReactComponent };